export default __webpack_public_path__ + "static/media/wallet-two.634b1724.svg";